import { get, post } from "../helpers/config";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";

export const useFetchStockOptions = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await get(
            `stock/options/list?stockSymbols=${data.stockSymbols}&significanceScoreRange=${data.significanceScoreRange}&eventDateFrom=${data.eventDateFrom}&eventDateTo=${data.eventDateTo}&expiryDate=${data.expiryDate}&isGuestUser=${data.isGuestUser}&pageNumber=${data.pageNumber}&pageSize=${data.pageSize}`);
    }, options);
};

export const useFetchStocks = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async () => {
        return await get("stock/list");
    }, options);
};

export const useFetchExpiryDates = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async () => {
        return await get("stock/expirydate/list");
    }, options);
};

export const useStockCreate = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await post(`stock?stockSymbols=${data.stockSymbol}`, false);
    }, options);
};

export const useFetchTradableStockOptions = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await get(`stock/options/tradable-assets?stockSymbol=${data.stockSymbol}`);
    }, options);
};

export const useFetchStockOptionsHighestOpenInterest = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await get(`stock/options/highest-oi?parentStockSymbol=${data.parentStockSymbol}`, false);
    }, options);
};

export const useFetchStockOptionsStockSymbols = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async () => {
        return await get("stock/option/stock-symbols", false);
    }, options);
};